
import daysSentence from './DaysSenteceReducers';

export default daysSentence;
